module.exports = __webpack_public_path__ + "img/16m005-02.c7b9bcfe.png";